import { parseRouteIdsFromPathname } from "@/utils/hooks/url/parse-route-ids";

/**
 * In local dev we have access to the environment id before the router "knows" about it,
 * so it's nice to just use it from here.
 *
 * First tries to extract from the path (e.g., /environments/[id]).
 * Falls back to checking the environmentId query parameter if not found in path.
 */
export function parseEnvironmentIdFromUrl(url: string): string | null {
  try {
    const urlObj = new URL(url, "https://dummy.com");
    const pathId = parseRouteIdsFromPathname(urlObj.pathname).environmentId;
    if (pathId != null) return pathId;
    const envId = urlObj.searchParams.get("environmentId");
    return envId && envId.length > 0 ? envId : null;
  } catch {
    return null;
  }
}
